var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableLayout',[_c('div',{attrs:{"slot":"table"},slot:"table"},[_c('b-table',{attrs:{"data":_vm.clientList,"columns":_vm.columns}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }